import Fondo from "../assets/fondoCpoint.png";
import Señor from "../assets/senor.png";

const Cpoint = () => {
	return (
		<>
			<div
				className="w-full h-screen bg-cover bg-center hidden md:flex items-start md:items-center justify-start"
				style={{ backgroundImage: `url(${Fondo})` }}
			>
				<div className="w-full md:w-1/2 text-white px-4 md:px-20 text-justify flex flex-col gap-3">
					<h1 className="text-xl md:text-8xl font-bold">CPoint</h1>
					<h2 className="text-md md:text-2xl">Recompensarte es el punto</h2>
					<p className="text-base md:text-lg">
						Beneficios Administrativos y Comerciales para empresa - Empleado -
						Comercio
					</p>
				</div>
			</div>
			<div className="h-screen w-full bg-black flex md:hidden flex-col justify-end">
				<div className="w-full md:w-1/2 text-white px-4 md:px-20 text-justify flex flex-col gap-3">
					<h1 className="text-xl md:text-8xl font-bold">CPoint</h1>
					<h2 className="text-md md:text-2xl">Recompensarte es el punto</h2>
					<p className="text-base md:text-lg">
						Beneficios Administrativos y Comerciales para empresa - Empleado -
						Comercio
					</p>
				</div>
				<img src={Señor} className="w-full aspect-square" alt="señor" />
			</div>
		</>
	);
};

export default Cpoint;
